<div *ngIf="errorMessage !== null" class="validation-error">{{ errorMessage }}</div>
